module.exports = __webpack_public_path__ + "static/media/bo.197a9d20.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bo.svg
// module id = 1193
// module chunks = 0